<form (ngSubmit)="onClinicDetailsFormSubmit(cdf)" #cdf="ngForm">
    <div class="d-flex flex-column page_container">
        <div class="row flex-grow-1 pb-3 pb-md-5">
            <div class="col-lg-6 col-md-8 col-sm-12 offset-lg-1 offset-md-1">
                <h1 class="app_page-title">{{reviewSubmittext}}</h1>
                <div class="review_info mb-5" *ngIf="isOn">
                    Please confirm the details below. When you’re ready, click “Submit” to send it over. Your local pharmacy specialist will contact you to confirm the details and start working on your clinic. Thank you for considering us to conduct a clinic for your organization!
                </div>
                <!-- <div class="clinic_card shadow mb-5" *ngIf="isOn">
                    <div class="clinic_card-top">
                        <span class="clinic_card-icon shadow">
                            <img src="assets/images/clinic-icon.png" width="22" height="24" alt="" />
                        </span>
                    </div>
                    <div class="clinic_card-bottom">
                        <span class="clinic_card-name">{{aci_clinicName}}</span>
                        <span class="clinic_card-details mb-3">COVID-19, A1C Testing, Flu, Shingles, Lorem Ipsum</span>
                        <span class="clinic_card-title">Clinic dates</span>
                        <span class="clinic_card-date mb-3">{{aci_isthereaspecificdate}}</span>
                        <span class="clinic_card-address">
                            {{aci_streetaddress}}
                        </span>
                        <hr>
                        <div class="clinic_card-actions">
                            <button type="button" class="btn btn-outline-secondary rounded-pill px-4" (click)="clinicDetails('edit')">View clinic deails</button>
                        </div>
                    </div>
                </div> -->
                <span *ngIf="isOn">
                <div class="clinic_card shadow mb-5" *ngFor="let clinic of clinicsList; let i = index;" >
                    <div class="clinic_card-top">
                        <span class="clinic_card-icon shadow">
                            <img src="assets/images/clinic-icon.png" width="22" height="24" alt="" />
                        </span>
                    </div>
                    <div class="clinic_card-bottom">
                        <span class="clinic_card-name">{{clinic.aci_clinicname}}</span>
                        <span class="clinic_card-details mb-3">{{ clinic['aci_immunizationtype@OData.Community.Display.V1.FormattedValue']  }} {{ clinic['aci_clinicservicetype@OData.Community.Display.V1.FormattedValue']  }}</span>
                        <span class="clinic_card-title">Clinic dates</span>
                        <span class="clinic_card-date mb-3">{{ clinic.aci_isthereaspecificdateyoudliketohold ? clinic.aci_isthereaspecificdate : 'No, Dates are flexible'}}</span>
                        <span class="clinic_card-address">
                            {{ clinic.aci_streetaddress }}
                        </span>
                        <hr>
                        <div class="clinic_card-actions">
                            <button tabindex="0" type="button" class="btn btn-outline-secondary rounded-pill px-4" (click)="clinicDetails( 'edit',clinic)">View clinic details</button>
                        </div>
                    </div>
                </div>
            </span>
                <!-- <button type="button" aria-label="Add Additional Clinic Location" class="btn btn-outline-secondary rounded-pill px-4 mt-2" *ngIf="isOn" tabindex="0"><i class="bi bi-plus-lg me-1"></i>Add Additional Clinic Location</button> -->
                <div class="review_details" *ngIf="!isOn">
                    <div class="mb-3 bg-white border-rounded">
                        <div class="review_details-cont">
                            <div class="review_details-info">
                                <h3>Contact</h3>
                                <p>
                                    <b> {{firstName + " " +lastName}} </b><br>
                                      {{jobtitle}} <br>
                                    {{emailaddress1}}  <br>
                                    {{mobilephone}}
                                </p>
                            </div>
                            <div class="review_details-action mb-3 mb-lg-0">
                                <button tabindex="0" aria-label="Edit Contact" type="button"  class="btn btn-outline-secondary rounded-pill px-4" (click)="editDetails('contact')"><i class="bi bi-pencil me-2"></i>Edit</button>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 bg-white border-rounded">
                       <div class="review_details-cont">
                            <div class="review_details-info">
                                <h3>Organization</h3>
                                <p>
                                    <b> {{companyname}} </b><br>
                                    {{aci_companysize}} employees <br>
                                </p>
                            </div>
                            <div class="review_details-action mb-3 mb-lg-0">
                                <button type="button" tabindex="0" aria-label="Edit Organization" class="btn btn-outline-secondary rounded-pill px-4" (click)="editDetails('organisation')"><i class="bi bi-pencil me-2"></i>Edit</button>
                            </div>
                        </div> 
                    </div>
                    <div class="mb-3 bg-white border-rounded">
                        <div class="review_details-cont">
                            <div class="review_details-info">
                                <h3>Services</h3>
                                <p>
                                    Clinic type<br>
                                    <b>{{clinicType}}</b><br>
                                </p>
                              
                                    <span class="d-flex flex-wrap">
                                        <label *ngIf="covid19" class="badge rounded-pill">COVID 19</label>
                                        <label *ngIf="flu" class="badge rounded-pill" >Flu</label>
                                        <label *ngIf="pneumonia" class="badge rounded-pill">Pneumonia</label>
                                        <label *ngIf="shingrix" class="badge rounded-pill">Shingles</label>
                                        <label *ngIf="tdap" class="badge rounded-pill">Tetanus</label>
                                        <label *ngIf="Hepatitis"  class="badge rounded-pill">Hepatitis B</label>
                                        <label *ngIf="a1ctesting" class="badge rounded-pill">A1C</label>
                                        <label *ngIf="bloodglucose" class="badge rounded-pill">Blood Glucose</label>
                                        <label *ngIf="cholestrol" class="badge rounded-pill">Cholesterol/Lipid Panel</label>
                                        <label *ngIf="covid19testing" class="badge rounded-pill">Covid-19 Testing</label>
                                        <label *ngIf="travelhealth" class="badge rounded-pill">Travel Health</label>
                                    </span>
                                   

                               
                            </div>
                            <div class="review_details-action mt-3 mb-3 mb-lg-0 mt-lg-0">
                                <button type="button" type="button" tabindex="0" aria-label="Edit service" class="btn btn-outline-secondary rounded-pill px-4" (click)="editDetails('services')"><i class="bi bi-pencil me-2"></i>Edit</button>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 bg-white border-rounded">
                        <div class="review_details-cont">
                            <div class="review_details-info">
                                <h3>Clinic Details</h3>
                                <p >Clinic days</p>
                                <span *ngIf="aci_sunday" class="badge rounded-pill">Sunday</span>
                                <span *ngIf="aci_monday" class="badge rounded-pill">Monday</span>
                                <span *ngIf="aci_tuesday" class="badge rounded-pill">Tuesday</span>
                                <span  *ngIf="aci_wednesday" class="badge rounded-pill">Wednesday</span>
                                <span *ngIf="aci_thursday" class="badge rounded-pill">Thursday</span>
                                <span *ngIf="aci_friday"  class="badge rounded-pill">Friday</span>
                                <span *ngIf="aci_saturday" class="badge rounded-pill">Saturday</span>
                            </div>
                            <div class="review_details-action">
                                <button type="button" tabindex="0" aria-label="Edit clinic-details" class="btn btn-outline-secondary rounded-pill px-4 d-none d-md-block" (click)="editDetails('clinic-details')"><i class="bi bi-pencil me-2"></i>Edit</button>
                            </div>
                        </div>
                        <div class="p-3 pt-0">
                            <hr>
                            <p tabindex="0"   >
                                Dates<br>
                                <!-- <b >{{aci_isthereaspecificdate}}</b> -->
                                <b aria-hidden="true">{{aci_isthereaspecificdate}}</b>
                                <!-- <span aria-hidden="true">★★★★☆ 4.0 (123)</span> -->
                                <b class="visually-hidden">{{aci_isthereaspecificdate | date}}</b>
                            </p>
                            <hr>
                            <p>
                                Time<br>
                                <b>{{aci_proposedtimeofdays}}</b>
                            </p>                           
                            <hr>
                            <p>
                                Clinic name<br>
                                <b>{{aci_clinicName}}</b>
                            </p>
                            <hr>
                            <p>
                                On-site contact<br>
                                <b>{{aci_cliniccontactname + " " + aci_onsitecontactlastname}}</b>
                            </p>
                            <hr>
                            <p>
                                Contact number<br>
                                <b>{{aci_cliniccontactphonenumber}}</b>
                            </p>
                            <hr>
                            <p>
                                Address<br>
                                <b>{{aci_streetaddress}}</b>
                            </p>
                            <button type="button" class="btn btn-outline-secondary rounded-pill px-4 d-block d-md-none w-100" (click)="editDetails('clinic-details')" aria-label="Edit clinic details"><i class="bi bi-pencil me-2"></i>Edit</button>
                        </div>
                    </div>
                    <div class="mb-3 bg-white border-rounded">
                        <div class="review_details-cont">
                            <div class="review_details-info">
                                <h3>Billing</h3>
                            </div>
                            <div class="review_details-action d-none d-md-block">
                                <button type="button" tabindex="0" aria-label="Edit billing details" class="btn btn-outline-secondary rounded-pill px-4" (click)="editDetails('billing')"><i class="bi bi-pencil me-2"></i>Edit</button>
                            </div>
                        </div>
                        <div class="p-3 pt-0">
                            <hr>
                            <p *ngIf="aci_billyourparticipantsinsurers">
                                How will you bill for this clinic?<br>
                                <b>Bill your participant's insurer(s)</b>
                            </p>
                            <hr *ngIf="aci_billyourparticipantsinsurers">
                            <p *ngIf="aci_billyourparticipantsinsurers">
                                Do participants all share the same health plan?<br>
                                <b>{{aci_employeesoftheValue}}</b>
                            </p>
                            <hr *ngIf="aci_billyourparticipantsinsurers">
                            <p *ngIf="aci_billyourparticipantsinsurers">
                                If the participant's claim denied, who is responsible for reimbursing the pharmacy?<br>
                                <b>{{aci_responsibleforreimbursementtothepharmacyValue}}</b>
                            </p>
                            <hr *ngIf="aci_billyourparticipantsinsurers">
                            <p *ngIf="aci_collectpaymentfromparticipants">
                                Charge participants at the clinic<br>
                                <b>We can charge each participant at the time of service.</b>
                               
                            </p>
                            <hr  *ngIf="aci_collectpaymentfromparticipants">
                            
                            <p *ngIf="aci_billyourcompanydirectly">
                                Invoice your company directly<br>
                                <b>We can invoice your organization for all services provided.</b>
                               
                            </p>
                            <hr *ngIf="aci_billyourcompanydirectly">
                            <p *ngIf="aci_split_costwithparticipants">
                                I don't know<br>
                                <b>No worries! We will reach out to you directly and help you make the right choice for your clinic and participants.</b>
                            </p>
                            <button type="button" class="btn btn-outline-secondary rounded-pill px-4 d-block d-md-none w-100" (click)="editDetails('billing')"><i class="bi bi-pencil me-2" tabindex="0"></i>Edit</button>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12" *ngIf="isOn">
                    <button type="button" class="btn btn-lg btn-outline-secondary rounded-pill px-4 me-md-3" (click)="onPreviousClick()" (focus)='onPreviousButtonFocus()' tabindex="{{previuosButtonTabIndex}}">Previous</button>
                    <button type="submit" class="btn btn-lg btn-primary rounded-pill px-4 me-md-3" (focus)='onNextButtonFocus()' tabindex="0">Submit</button>
                </div>
                <div class="col-sm-12" *ngIf="!isOn">
                    <button type="button" aria-label="back" class="btn btn-outline-secondary rounded-pill px-4 me-3" (click)="clinicDetails('back','')" tabindex="0">Back</button>
                </div>
            </div>
        </div>
        <!-- <div class="row footer shadow">
            
        </div> -->
    </div>
</form>